<template>
    <div>
        <table class="table">
            <tbody>
                <app-list-konto-item class="btn-base"
                        v-for="item in list"
                                     :id="item.id"
                                     :name="item.name"
                                     :date="item.dateFrom"
                                     :trans="item.transactionAmountSum"
                                     :isTrans="false"
                ></app-list-konto-item>
            </tbody>
        </table>
    </div>
</template>

<script>
  import ListKontoItem from './ListKontoItem'
  import data from '../../data/konto'

  export default {
    data () {
      return {
        list: data
      }
    },
    components: {
      appListKontoItem: ListKontoItem
    }
  }
</script>

<style lang="scss" scoped>
    @import '../../styles/app';
</style>

